import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Section, useScrollSection } from "react-scroll-section";
import "../style/css/Works.css";
import { data } from "../data";
import { useEffect } from "react";

function Works() {
  const { i18n, t } = useTranslation(["common"]);

  const works = useScrollSection("works");

  const categories = [
    { id: "all", title: t("all") },
    { id: "react", title: "React" },
    { id: "mern", title: "MERN stack" },
    { id: "next", title: "Next" },
  ];

  const [selected, setSelected] = useState("all");

  const [filtereData, setFilteredData] = useState(data);

  const [animateGallery, setAnimateGallery] = useState(false);

  useEffect(() => {
    setAnimateGallery(true);
    setTimeout(() => {
      setAnimateGallery(false);
    }, 200);

    if (selected !== "all") {
      setFilteredData(data.filter((item) => item.category === selected));
    } else {
      setFilteredData(data);
    }
  }, [selected]);

  return (
    <Section id="works" style={{ width: "100%" }}>
      <div className="container w-container">
        <div className="gallery-container">
          <ul
            className={
              works.selected ? "gallery-filter active" : "gallery-filter"
            }
          >
            {categories.map((item) => (
              <li
                key={item.id}
                className={
                  item.id === selected ? "category active" : "category"
                }
                onClick={() => setSelected(item.id)}
              >
                <span>{item.title}</span>
              </li>
            ))}
          </ul>
          <div className="gallery">
            {filtereData.map((item) => (
              <div
                className={
                  animateGallery ? "gallery-item animate" : "gallery-item"
                }
                key={item.title}
              >
                <a href={item.link} target="_blank" rel="noreferrer">
                  <div className="gallery-item-inner">
                    <img src={item.img} alt={item.title} />
                    <div className="details">
                      <div className="content">
                        <h2>{item.title}</h2>
                        <p>
                          {i18n.resolvedLanguage === "fr"
                            ? item.descriptionFR
                            : i18n.resolvedLanguage === "es"
                            ? item.descriptionES
                            : item.descriptionEN}
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>


      
      </div>
    </Section>
  );
}

export default Works;
